Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.MultipleFields = (function () {
  function MultipleFields() {
    Monet.UI.Fields.Base.apply (this, arguments);
    this.createBaseStructure();

    this.fields = [];
    this.fieldRenderedList = [];
    this.data = [];

    this.isEmpty = function () {
      return !this.fieldRenderedList.filter(field => field.getValue()).length;
    }

    this.setFields = function (fields) {
      this.fields = fields;
    }

    this.getValue = function () {
      return this.fieldRenderedList.reduce((acc, field) => {
        acc[field.name] = field.getValue();
        return acc;
      }, {});
    }

    this.setValue = function (data) {
      if (data) {
        this.fieldRenderedList.forEach((field) => field.setValue(data[field.name]));
      }
    }

    this.renderFields = function () {
      const container = document.createElement('div');
      const fieldList = document.createDocumentFragment();
      container.setAttribute('class', 'multiplefields__container');
      this.fields.forEach(field => {
        const fieldRendered = new Monet.UI.Fields.Render(field).render();
        this.fieldRenderedList.push(fieldRendered);
        fieldList.appendChild(fieldRendered.rootEl);
      });
      container.appendChild(fieldList);
      this.rootEl.appendChild(container);
    }

    this.render = function () {
      this.renderFields();
      return this.rootEl;
    }
  }

  return MultipleFields;
}())